import {RfcStep} from '@common/types/rfc';
import {Section125GroupInfo} from './sections/Section125GroupInfo';
import {Section125Admin} from './sections/Section125Admin';
import {Section125Contacts} from './sections/Section125Contacts';
import {Section125Payroll} from './sections/Section125Payroll';
import {Section125Agent} from './sections/Section125Agent';
import {MecGroupInfo} from './sections/MecGroupInfo';
import {MecAdmin} from './sections/MecAdmin';
import {MecContacts} from './sections/MecContacts';
import {MecPayroll} from './sections/MecPayroll';
import {MecAgent} from './sections/MecAgent';
import {AchForm} from './sections/AchForm';
import {ReviewSummary} from './sections/ReviewSummary';
import {ClientPortalAccessForm} from '@client/pages/rfc/forms/sections/ClientPortalAccessForm';

export function RfcStepForm(props: {
  currentStep: RfcStep;
  disableFormCopy?: boolean;
  showEnrollmentType?: boolean;
  showPepm?: boolean;
}) {
  const showEnrollmentType = !!props.showEnrollmentType;
  const showPepm = !!props.showPepm;
  switch (props.currentStep) {
    case RfcStep.SECTION_125_FORM_GROUP_INFO:
      return <Section125GroupInfo />;
    case RfcStep.SECTION_125_FORM_ADMIN:
      return <Section125Admin showEnrollmentType={showEnrollmentType} />;
    case RfcStep.SECTION_125_FORM_CONTACTS:
      return <Section125Contacts />;
    case RfcStep.SECTION_125_FORM_PAYROLL_INFO:
      return <Section125Payroll />;
    case RfcStep.SECTION_125_FORM_AGENT:
      return <Section125Agent showPepm={showPepm} />;

    case RfcStep.MEC_FORM_GROUP_INFO:
      return <MecGroupInfo disableFormCopy={props.disableFormCopy} />;
    case RfcStep.MEC_FORM_ADMIN:
      return (
        <MecAdmin
          disableFormCopy={props.disableFormCopy}
          showEnrollmentType={showEnrollmentType}
        />
      );
    case RfcStep.MEC_FORM_CONTACTS:
      return <MecContacts disableFormCopy={props.disableFormCopy} />;
    case RfcStep.MEC_FORM_PAYROLL_INFO:
      return <MecPayroll disableFormCopy={props.disableFormCopy} />;
    case RfcStep.MEC_FORM_AGENT:
      return <MecAgent disableFormCopy={props.disableFormCopy} showPepm={showPepm} />;

    case RfcStep.ACH_FORM:
      return <AchForm />;
    case RfcStep.CLIENT_PORTAL_ACCESS:
      return <ClientPortalAccessForm />;
    case RfcStep.REVIEW:
      return <ReviewSummary />;
    case RfcStep.INITIAL:
    default:
      return <div />;
  }
}
